import { ComponentType } from 'react';

import EmailField from 'components/Fields/EmailField/EmailField';
import TextField from 'components/Fields/TextField/TextField';
import TextareaField from 'components/Fields/TextareaField/TextareaField';

import { CLAIMANT_DETAILS } from '../content-legal-reporting-config';

type StepField = {
  FieldComponent: ComponentType<any>;
  fieldName: string;
  fieldLabel: string;
  required: boolean;
  maxLength: number;
  errorMessageKey?: string;
};

export const STEP_1_FIELDS: StepField[] = [
  {
    FieldComponent: TextField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_FIRST_NAME,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_FIRST_NAME,
    required: true,
    maxLength: 40,
  },
  {
    FieldComponent: TextField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_LAST_NAME,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_LAST_NAME,
    required: true,
    maxLength: 80,
  },
  {
    FieldComponent: TextField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_COMPANY_NAME,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_COMPANY_NAME,
    required: false,
    maxLength: 80,
  },
  {
    FieldComponent: TextField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_ADDRESS,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_ADDRESS,
    required: false,
    maxLength: 255,
  },
  {
    FieldComponent: TextField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_PHONE,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_PHONE,
    required: false,
    maxLength: 40,
  },
  {
    FieldComponent: EmailField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_EMAIL,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_EMAIL,
    required: true,
    maxLength: 80,
    errorMessageKey: 'infringement_claim_form:email_invalid',
  },
  {
    FieldComponent: TextareaField,
    fieldName: CLAIMANT_DETAILS.fields.CLAIMANT_MORE_INFO,
    fieldLabel: CLAIMANT_DETAILS.labels.CLAIMANT_MORE_INFO,
    required: false,
    maxLength: 200,
  },
];
